import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageHeader } from '@/components/layout/PageHeader'
import { Breadcrumb } from '@/components/layout/Breadcrumb'
import { Button } from '@/components/ui/Button'
import { PageError } from '@/components/ui/PageAsyncState'
import { FormField } from '@/components/forms/FormField'
import { bomService } from '@/services/boms'

const inputClass =
  'w-full rounded-[var(--radius-sm)] border border-[var(--color-border)] bg-white px-2.5 py-1.5 text-sm outline-none focus:border-[var(--color-accent)]'

export function BomFormPage() {
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [versionLabel, setVersionLabel] = useState('')
  const [codeHint, setCodeHint] = useState('')
  const [productId, setProductId] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setSaving(true)
    try {
      const created = await bomService.create({
        name: name.trim(),
        version_label: versionLabel.trim() || undefined,
        code_hint: codeHint.trim() || null,
        product_id: productId.trim() || null,
      })
      navigate(`/purchasing/boms/${created.id}`)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Không thể tạo BOM')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div>
      <Breadcrumb
        items={[
          { label: 'Trang chủ', to: '/' },
          { label: 'Mua hàng', to: '/purchasing' },
          { label: 'Định mức (BOM)', to: '/purchasing/boms' },
          { label: 'BOM mới' },
        ]}
      />
      <PageHeader
        title="Tạo BOM mới"
        subtitle="Header draft (inactive) — thêm dòng trên trang chi tiết"
      />

      <form
        onSubmit={(e) => void handleSubmit(e)}
        className="max-w-2xl space-y-3"
      >
        {error ? <PageError message={error} /> : null}

        <section className="border border-[var(--color-border)] bg-white">
          <div className="border-b border-[var(--color-border)] bg-slate-50 px-3 py-2 text-xs font-semibold tracking-wide text-slate-600 uppercase">
            Thông tin BOM
          </div>
          <div className="grid grid-cols-1 gap-3 p-3 sm:grid-cols-2 sm:p-4">
            <FormField label="Tên" required>
              <input
                required
                className={inputClass}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Cabinet BOM"
              />
            </FormField>
            <FormField label="Version label">
              <input
                className={inputClass}
                value={versionLabel}
                onChange={(e) => setVersionLabel(e.target.value)}
                placeholder="Để trống → server dùng V1"
              />
            </FormField>
            <FormField label="Mã gợi ý (code_hint)">
              <input
                className={inputClass}
                value={codeHint}
                onChange={(e) => setCodeHint(e.target.value)}
                placeholder="MP560"
              />
            </FormField>
            <FormField label="Product ID (optional)">
              <input
                className={inputClass}
                value={productId}
                onChange={(e) => setProductId(e.target.value)}
                placeholder="prod-…"
              />
            </FormField>
          </div>
        </section>

        <div className="flex justify-end gap-2 border border-[var(--color-border)] bg-slate-50 px-3 py-2.5">
          <Button
            type="button"
            variant="secondary"
            onClick={() => navigate('/purchasing/boms')}
            disabled={saving}
          >
            Hủy
          </Button>
          <Button type="submit" disabled={saving}>
            {saving ? 'Đang lưu…' : 'Tạo BOM'}
          </Button>
        </div>
      </form>
    </div>
  )
}
